<template>
    <settings-page :title="title" :description="description">
        <div>
            <h2 class="text-setting__title">Recaptcha v3 API KEY</h2>
            <input
                v-model="recaptchaKey"
                type="text"
                class="flex-form__input"
                @change="onInput"
            >
        </div>
    </settings-page>
</template>

<script>
import { mapState } from 'vuex';

import SettingsPage from '@/components/settings/shared/settings-page';

export default {
    name: 'settings-google',
    components: { SettingsPage },

    data() {
        return {
            title: 'Google API',
            description: 'This section controls API keys for Google',
            recaptchaKey: '',
            mapsKey: 'AIzaSyCoRnCCV8jlOZbPPq4xXICEEFcDcUdYh4U',
        };
    },

    computed: {
        ...mapState({
            settings: state => state.settings,
        }),
    },

    mounted() {
        this.recaptchaKey = this.settings.google.recaptchaKey;
        this.mapsKey = this.settings.google.mapsKey;
    },

    methods: {
        onInput() {
            this.$emit('input', 'google', {
                recaptchaKey: this.recaptchaKey,
                mapsKey: this.mapsKey,
            });
        },
    },
};
</script>
